
export const load = path => () => import(/* webpackChunkName: "[request]" */`../components/${path}`)
.catch(error => {
    location.reload()
    console.log(error);
})


// WEBPACK FOOTER //
// ./resources/js/router/component-loader.js